<template>
    <div>
        <oss-data-table :headers="headers" :items="items" :striped="true" :loading="loading">
            <template #no-data>
                <v-row no-gutters class="pa-2 d-flex align-center rounded-xl" style="background-color: #fef8ee;">
                    <v-icon size="small" icon="$fa-bullseye"/>
                    <span class="text-body-1 ml-4">Pour tous les clients de mon cabinet</span>
                </v-row>
            </template>
            <template #item.type="{ item }">
                <v-icon>{{ itemIcon(item.type) }}</v-icon>
            </template>
            <template #item.actions="{ item }">
                <div class="d-flex justify-space-between">
                    <v-btn-trash @click="removeItem(item)" size="small" />
                </div>
            </template>
        </oss-data-table>
    </div>
</template>

<script lang="ts">
import OssDataTable from "../ossComponents/ossDataTable2.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

@Component({
    components: {
        OssDataTable,
    },
    emits: ["scopedCompanies"],
})
export class ScopeTable extends Vue {
    @Prop({ type: String }) id!: string;

    @Model({ name: "search" }) searchSync!: string;

    @Model({ name: "clients" }) clientsSync!: any[];

    @Model({ name: "activities" }) activitiesSync!: any[];

    @Model({ name: "taxSystems" }) taxSystemsSync!: string[];

    loading = false;

    get headers() {
        return [
            { text: "Type", value: "type" },
            { text: "Nom", value: "name", width: "70%" },
            { text: "Actions", value: "actions" },
        ];
    }

    get items() {
        const items: any[] = [];
        if (this.clientsSync) {
            const clients = this.clientsSync.map((c) => ({
                id: c.id,
                type: "company",
                name: c.shortName || c.name,
            }));
            items.push(...clients);
        }

        if (this.activitiesSync) {
            const activities = this.activitiesSync.map((a) => ({
                id: a.id,
                type: "activity",
                name: `${a.name} - ${a.description}`,
            }));
            items.push(...activities);
        }

        if (this.taxSystemsSync) {
            const taxSystems = this.taxSystemsSync.map((a) => ({
                id: a,
                type: "taxSystems",
                name: this.taxSystemtitle(a),
            }));
            items.push(...taxSystems);
        }

        if (this.searchSync) {
            const search = this.searchSync.toLowerCase();
            return items.filter((i) => i.name.toLowerCase().includes(search));
        }
        return items;
    }

    itemIcon(type: string) {
        switch (type) {
            case "company":
                return "$oss-company";
            case "activity":
                return "$oss-activity";
            case "taxSystems":
                return "$fa-gear";
            default:
                return "";
        }
    }

    taxSystemtitle(system) {
        switch (system) {
            case "RS_IS":
                return "BIC régime simplifié à l'Impôt sur les Sociétés";
            case "RS_IR":
                return "BIC régime simplifié à l'Impôt sur le Revenu";
            case "RN_IS":
                return "BIC régime normal à l'Impôt sur les Sociétés";
            case "RN_IR":
                return "BIC régime normal à l'Impôt sur le Revenu";
            case "BIC":
                return "BIC";
            case "BNC":
                return "BNC";
            case "RF":
                return "RF";
            default:
                break;
        }
    }

    removeItem(item) {
        switch (item.type) {
            case "taxSystems":
                debugger
                const taxSystemIndex = this.taxSystemsSync.findIndex((t) => t === item.id);
                if (taxSystemIndex !== -1) {
                    this.taxSystemsSync.splice(taxSystemIndex, 1);
                }
                break;
            case "activity":
                const activityIndex = this.activitiesSync.findIndex((a) => a.id === item.id);
                if (activityIndex !== -1) {
                    this.activitiesSync.splice(activityIndex, 1);
                }
                break;
            case "company":
                const clientIndex = this.clientsSync.findIndex((c) => c.id === item.id);
                if (clientIndex !== -1) {
                    this.clientsSync.splice(clientIndex, 1);
                }
                break;
        }
    }
}

export default toNative(ScopeTable);
</script>
